import React, { useState, useEffect } from 'react';
import api from '../services/api';

function computeCells(blocks) {
  const n = blocks.length || 1;
  const cols = Math.ceil(Math.sqrt(n));
  const rows = Math.ceil(n / cols);
  const x0 = 6, y0 = 11, W = 88, H = 77;
  const cw = W / cols, ch = H / rows;
  return blocks.map((b, i) => ({
    id: b,
    label: 'Q' + b,
    x: x0 + (i % cols) * cw,
    y: y0 + Math.floor(i / cols) * ch,
    w: cw,
    h: ch,
  }));
}

export default function CemeteryMap({ marker }) {
  const [zoom, setZoom] = useState(1);
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    setZoom(1);
  }, [marker]);

  useEffect(() => {
    api.get('/blocks')
      .then(({ data }) => setBlocks(data.map((d) => d.block)))
      .catch(() => {});
  }, []);

  const cells = computeCells(blocks);
  const activeBlock = marker ? marker.block : null;

  return (
    <div className="map-container">
      <div className="map-header">
        <h3>Mapa do Cemitério</h3>
        <div className="map-controls">
          <button onClick={() => setZoom(z => Math.min(z + 0.2, 2))}>+</button>
          <button onClick={() => setZoom(z => Math.max(z - 0.2, 1))}>−</button>
        </div>
      </div>
      <div className="map-canvas">
        <div className="map-north">N ↑</div>
        <svg
          viewBox="0 0 100 100"
          style={{
            width: '100%',
            height: '100%',
            transform: `scale(${zoom})`,
            transformOrigin: 'center',
            transition: 'transform 0.3s ease',
          }}
        >
          <rect width="100" height="100" fill="#F5F8F7" />

          <rect x="40" y="92" width="20" height="6" fill="#075132" rx="1" />
          <text x="50" y="96" textAnchor="middle" fill="#fff" fontSize="3" fontWeight="600">
            ENTRADA
          </text>

          <line x1="50" y1="92" x2="50" y2="10" stroke="#DDE7E3" strokeWidth="0.5" />
          <line x1="5" y1="50" x2="95" y2="50" stroke="#DDE7E3" strokeWidth="0.5" />

          {cells.map((block) => {
            const active = block.id === activeBlock;
            const fontSize = Math.min(4, 33 / block.label.length);
            return (
              <g key={block.id}>
                <rect
                  x={block.x}
                  y={block.y}
                  width={block.w}
                  height={block.h}
                  fill={active ? '#E8F4EF' : '#FFFFFF'}
                  stroke={active ? '#188A43' : '#DDE7E3'}
                  strokeWidth={active ? 0.5 : 0.3}
                  rx="1"
                />
                <text
                  x={block.x + block.w / 2}
                  y={block.y + block.h / 2}
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fill={active ? '#075132' : '#66756F'}
                  fontSize={fontSize}
                  fontWeight="600"
                >
                  {block.label}
                </text>
              </g>
            );
          })}

          {marker && (
            <g>
              <circle
                cx={marker.x}
                cy={marker.y}
                r="2.5"
                fill="#F47729"
                stroke="#fff"
                strokeWidth="0.5"
              />
              <circle
                cx={marker.x}
                cy={marker.y}
                r="4"
                fill="none"
                stroke="#F47729"
                strokeWidth="0.3"
                opacity="0.5"
              />
              <text
                x={marker.x}
                y={marker.y + 8}
                textAnchor="middle"
                fill="#17352C"
                fontSize="2.2"
                fontWeight="700"
              >
                Jazigo {marker.number}
              </text>
            </g>
          )}
        </svg>
      </div>
      <div className="map-legend">
        <div className="legend-item">
          <div className="legend-dot selected"></div>
          <span>Jazigo selecionado</span>
        </div>
        <div className="legend-item">
          <div className="legend-dot other"></div>
          <span>Demais quadras</span>
        </div>
      </div>
    </div>
  );
}
